// extracted by mini-css-extract-plugin
export default {"Isolating":"DHCpYaRiT5_7qCK7slur","isolating":"DHCpYaRiT5_7qCK7slur"};